import { render } from "./left.vue?vue&type=template&id=493c6d50&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"

import "./left.vue?vue&type=style&index=0&id=493c6d50&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./left.vue?vue&type=style&index=1&id=493c6d50&scoped=true&lang=css"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493c6d50"]])

export default __exports__